import { render, staticRenderFns } from "./CoverageAreas.vue?vue&type=template&id=020e8483&"
import script from "./CoverageAreas.vue?vue&type=script&lang=js&"
export * from "./CoverageAreas.vue?vue&type=script&lang=js&"
import style0 from "./CoverageAreas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports